import { render, staticRenderFns } from "./GestionTraitementsView.vue?vue&type=template&id=12274dd0"
import script from "./GestionTraitementsView.vue?vue&type=script&lang=js"
export * from "./GestionTraitementsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports